module.exports = __webpack_public_path__ + "media/stylesheets/images/media/user_way_hero-1877efc46314f24f076febe667db8d21.png";